export const FETCH_SUCCESS='FETCH_SUCCESS';
export const FETCH_FAILED='FETCH_FAILED';
export const ADD_STATE_WISE='ADD_STATE_WISE';
export const ADD_DAILY_CASES='ADD_DAILY_CASES';
export const ADD_DISTRICT_WISE='ADD_DISTRICT_WISE';
export const TOTAL_CASES='TOTAL_CASES';
export const ADD_ROW_TO_SAVE_USER='ADD_ROW_TO_SAVE_USER';
export const TOGGLE_HEART='TOGGLE_HEART';
export const ADD_ZONE_DATA='ADD_ZONE_DATA';
export const WORLD_TOTAL_CASES='WORLD_TOTAL_CASES'
  